import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
var ReactSuperSelect = require('react-super-select');
const moment = require('moment');
const crypto = require('crypto');

class Surveys extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			selectedSection: 'SurveySettings',
			addingSetting: false,
			editBox: false,
			addBox: false,
			loading: false,
			filterBy: {}
		};
	}

	newID() {
		var hexstring = crypto.randomBytes(10).toString("hex");
		return [hexstring.substring(0, 19), new Date().getTime().toString()].join('');
	}

	checkState = (option) => {
		console.log(this.state);
	}

	showEditBox = (desc, data) => e => {
		console.log('showEditBox');
		console.log(desc);
		console.log(data);

		this.setState({
			editBox: desc,
			selectedObject: data,
			originalObject:  JSON.parse(JSON.stringify(data)),
			loading: false
		})
	}

	showAddBox = (type) => e => {
		var data = {}

		if (type === 'SurveyQuestions') { //todo: update this to dynamically add languages from memory setting
			data = {
				questionData: {
					English: {
						promptType: 'text',
						promptText: '',
						promptUrl: '',
						allowTypeChange: true
					},
					Spanish: {
						promptType: 'text',
						promptText: '',
						promptUrl: '',
						allowTypeChange: true
					},
					Somali: {
						promptType: 'upload',
						promptText: '',
						promptUrl: '',
						allowTypeChange: false
					},
					Hmong: {
						promptType: 'upload',
						promptText: '',
						promptUrl: '',
						allowTypeChange: false
					}
				},
				questionOption1: '',
				questionOption2: '',
				questionOption3: '',
				questionOption4: '',
				questionOption5: '',
				questionActive: false,
				questionPosition: this.props.data.Surveys.surveyQuestions ? Object.keys(this.props.data.Surveys.surveyQuestions).length + 1 : 0,
				questionVersion: 0,
				questionDescription: '',
				enableVoicemail: false
			}
		}
		console.log('blank data is ');
		console.log(data);
		this.setState({
			addBox: type,
			setting: {},
			loading: false,
			selectedObject: data,
			originalObject:  JSON.parse(JSON.stringify(data))
		})
	}

	showDeleteBox = (type, data) => e => {
		e.stopPropagation()
		this.setState({ deleteBox: type, selectedObject: data, loading: false })
	}

	editDate = (desc, data) => e => {
		console.log('data');
	}

	editParam = (param, param2, param3) => (e) => {
		console.log('editParam')

		let newSetting =  JSON.parse(JSON.stringify(this.state.selectedObject));
		if (param3) {
			newSetting[param][param2][param3] = e.target.value
		} else if (param2) {
			newSetting[param][param2] = e.target.value
		} else {
			newSetting[param] = e.target.value
		}

		this.setState({ selectedObject: newSetting, loading: false })

		console.log(this.state);
	}

	toggleSettingPromptType = (language) => (e) => {
		let newSetting =  JSON.parse(JSON.stringify(this.state.selectedObject));
		console.log('toggleSettingPromptType');
		console.log(e);

		newSetting.settingType = e.id;
		newSetting.settingValue = e.name;
		this.setState({selectedObject: newSetting, loading: false})
	}

	toggleQuestionType = (language) => (e) => {
		let newSetting =  JSON.parse(JSON.stringify(this.state.selectedObject));

		newSetting.questionData[language].promptType = e.id;
		this.setState({selectedObject: newSetting, loading: false})
	}

	toggle = (param) => (e) => {
		console.log('toggle')
		console.log(this.state.selectedObject);
		let newSetting =  JSON.parse(JSON.stringify(this.state.selectedObject));
		newSetting[param] = this.state.selectedObject[param] ? false : true
		this.setState({ selectedObject: newSetting, loading: false })
	}

	cancel = () => {
		console.log('cancel');
		this.setState({
			editBox: false,
			addBox: false,
			deleteBox: false,
			addingSetting: false,
			loading: false,
			selectedObject: false,
			originalObject: false,
			error: false
		})

		console.log(this.state);
	}

	toggleSection = (option) => {
		if (option) {
			this.setState({ selectedSection: option.id, error: '' });
		}
	}

	confirmChanges = (type, data) => (e) => {
		if (type === 'setting') {
			console.log('data.setting');
			console.log(data);
			if (data.settingType === 'upload' && data.settingPromptUrl.length < 1) {
				this.setState({ error: 'Please upload a .wav file for ' + data.settingName })
				return
			} else if (data.settingType === 'tts' && data.settingPromptText.length < 1) {
				this.setState({ error: 'Please enter verbiage for ' + data.settingName })
				return
			}

			this.setState({
				error: false,
				loading: true
			})
			this.props.ws.send(JSON.stringify({ route: 'editSurveySettings', setting: data }))
			console.log('will save ' + type + ':');
			console.log(data);

		} else if (type === 'SurveyQuestions') {
			for (let i in data.questionData) {
				if (data.questionData[i].promptType == 'text' && data.questionData[i].promptText.length < 1) {
					//this.setState({ error: 'Please enter verbiage for Survey Question ' + i })
					//return
				} else if (data.questionData[i].promptType == 'upload' && data.questionData[i].promptUrl.length < 1) {
					//this.setState({ error: 'Please upload a .wav file for Survey Question ' + i })
					//return
				} else if (data.questionData[i].promptText.length > 500) {
					this.setState({ error: 'Survey Question ' + i + ' is too long.' })
					return
				}
			}
			if (!data.enableVoicemail && data.questionOption1.length < 1) {
				this.setState({ error: 'Please enter a description for Survey Option 1' })
			} else if (data.questionOption2.length < 1) {
				this.setState({ error: 'Please enter a description for Survey Option 2' })
			} else if (data.questionOption3.length < 1) {
				this.setState({ error: 'Please enter a description for Survey Option 3' })
			} else if (data.questionOption4.length < 1) {
				this.setState({ error: 'Please enter a description for Survey Option 4' })
			} else if (data.questionOption5.length < 1) {
				this.setState({ error: 'Please enter a description for Survey Option 5' })
			} else {
				var oldData = this.state.originalObject;

				if (data.enableVoicemail) {
					data.questionOption1 =  'Leave A Voicemail'
				} 
				console.log(data);

				//if this is a new entry or if an edit triggers a new entry
				let changeDetected = false;

				for (let i in data.questionData) {
					if (data.questionData[i].promptType != oldData.questionData[i].promptType || data.questionData[i].promptText != oldData.questionData[i].promptText || data.questionData[i].promptUrl != oldData.questionData[i].promptUrl) {
						console.log ('change detected at questionData');
						console.log(data.questionData[i]);
						console.log(oldData.questionData[i]);
						changeDetected = true;
					}
				}

				if (!data.questionId || data.questionDescription != oldData.questionDescription || data.questionOption1 != oldData.questionOption1 || data.questionOption2 != oldData.questionOption2 || data.questionOption3 != oldData.questionOption3 || data.questionOption4 != oldData.questionOption4 || data.questionOption5 != oldData.questionOption5 || data.enableVoicemail != oldData.enableVoicemail) {
					console.log('change detected at questionDescription or questionOptions')
					changeDetected = true;
				}

				if (changeDetected) {
					//console.log('data');
					//console.log(data);
					//console.log('oldData');
					//console.log(oldData);
					this.setState({
						error: false,
						loading: true,
					})
					let newVersion = data.questionVersion + 1;

					for (let i in this.props.data.Surveys.surveyQuestions) {
						if (this.props.data.Surveys.surveyQuestions[i].questionDescription == data.questionDescription) {
							if (this.props.data.Surveys.surveyQuestions[i].questionVersion >= newVersion) {
								newVersion = this.props.data.Surveys.surveyQuestions[i].questionVersion + 1;
							}
						}
					}
					data.questionVersion = newVersion;

					data.questionDatetimeCreated = new Date().toISOString();
					//console.log('datetime updated');

					
					//console.log('data iiiiis...')
					//console.log(data);
					
					this.props.ws.send(JSON.stringify({ route: 'addSurveyQuestions', setting: data }))

					if (oldData.questionId) {
						//console.log('disable old survey question');
						oldData.questionActive = false;
						//console.log(oldData);
						oldData.questionPosition = this.props.data.Surveys.surveyQuestions ? Object.keys(this.props.data.Surveys.surveyQuestions).length + 1 : 0;
						//console.log('position is ' + oldData.questionPosition);

						this.props.ws.send(JSON.stringify({ route: 'editSurveyQuestions', setting: oldData }))
					}

				} else {	//otherwise we can edit an existing entry.  The only thing that can be edited is making the active option true/false.
					this.setState({
						error: false,
						loading: true
					})
					this.props.ws.send(JSON.stringify({ route: 'editSurveyQuestions', setting: data }))
					//console.log('data is...')
					//console.log(data);
				}
				console.log('will save ' + type + ':');
				console.log(data);
			}

		}
	}

	confirmDelete = (type, data) => e => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'delete' + type, setting: data }))
	}

	moveQuestionUp = (data) => e => {
		e.stopPropagation()
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'moveSurveyQuestionUp', setting: data }))
	}

	moveQuestionDown = (data) => e => {
		e.stopPropagation()
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'moveSurveyQuestionDown', setting: data }));
	}

	uploadQuestionPrompt = (language) => (e) => {
		console.log('uploadQuestionPrompt');
		console.log(language);

		let newObject =  JSON.parse(JSON.stringify(this.state.selectedObject));
		let promptId = this.newID();
		language = language.charAt(0).toUpperCase() + language.slice(1);

		if (e.target.files.length > 0) {	
			newObject.questionData[language].promptUrl = this.props.data.Surveys.appLocation + '/getUploadedSurvey?id=' + promptId

			this.setState({ selectedObject: newObject })

			this.fileReader = new FileReader()
			console.log('fileReader');
			this.setState({ loading: true });

			this.fileReader.onload = (event) => {
				console.log('sending')
				this.props.ws.send(JSON.stringify({ route: 'uploadSurveyPrompt', id: promptId, file: this.fileReader.result.split(';base64,').pop() }))
				this.setState({ loading: false });

			}
		}

		this.fileReader.readAsDataURL(e.target.files[0])
	}

	uploadSettingPrompt = () => (e) => {
		console.log('uploadSettingPrompt');

		let newObject =  JSON.parse(JSON.stringify(this.state.selectedObject));
		let promptId = this.newID();

		if (e.target.files.length > 0) {			
			newObject.settingPromptUrl = this.props.data.Surveys.appLocation + '/getUploadedSurvey?id=' + promptId

			this.setState({ selectedObject: newObject })

			this.fileReader = new FileReader()
			console.log('fileReader');
			this.setState({ loading: true });

			this.fileReader.onload = (event) => {
				console.log('sending')
				this.props.ws.send(JSON.stringify({ route: 'uploadSurveyPrompt', id: promptId, file: this.fileReader.result.split(';base64,').pop() }))
				this.setState({ loading: false });

			}
		}

		this.fileReader.readAsDataURL(e.target.files[0])
	}

	sortFunc(sortBy, sortOrder) {
		return function (a, b) {
			if (sortBy === 'dateRange') {
				return new Date(a.StartDateTime).getTime() > new Date(b.StartDateTime).getTime() ? 1 * sortOrder : -1 * sortOrder
			}
			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.ID > b.ID ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			} else if (!(sortBy in a) && !(sortBy in b)) {
				return a.ID > b.ID ? 1 * sortOrder : -1 * sortOrder
			} else {

				return sortBy in a ? -1 : 1
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel();
		}
	}

	render() {
		//console.log('this.props');
		//console.log(this.props);
		if (this.props.active) {
			let contentMain, contentEditBox
			
			//make sure data displayed on page is by value and not by reference
			let data = JSON.parse(JSON.stringify(this.props.data));

			contentMain = []

			if (data.Surveys.showSettings) {
				let settingsList = [];
				for (let i in data.Surveys.settings) {
					let setting = data.Surveys.settings[i];
					if (setting.settingType == "boolean") {
						settingsList.push(
							<div className="dataRow" key={setting.settingId} onClick={this.showEditBox('setting', setting)}>
								<span style={{ flex: '1 0 48%', textAlign: 'right' }}>{setting.settingDisplayName}</span>
								<span style={{ flex: '1 0 4%', textAlign: 'right' }}>{}</span>
								<span style={{ flex: '1 0 48%', textAlign: 'left' }}>
									<div className="activeBox">
										<div className={setting.settingValue ? "enabled" : "disabled"}></div>
									</div>
								</span>
							</div>
						)
					} else {
						settingsList.push(
							<div className="dataRow" key={setting.settingId} onClick={this.showEditBox('setting', setting)}>
								<span style={{ flex: '1 0 48%', textAlign: 'right' }}>{setting.settingDisplayName}</span>
								<span style={{ flex: '1 0 4%', textAlign: 'right' }}>{}</span>
								<span style={{ flex: '1 0 48%', textAlign: 'left' }}>{setting.settingValue.toString()}</span>
							</div>
						)
					}
				}

				contentMain.push(
					<div>
						<div className="viewHeader">
							<h1>Survey Settings</h1>
						</div>
						{settingsList}
						<h1> </h1>
					</div>
				)

			}

			if (data.Surveys.showSurveyQuestions) {
				contentMain.push(<img src={this.props.img.plus} className="plusButton" alt="Add A Question" onClick={this.showAddBox('SurveyQuestions')} />);

				contentMain.push(
					<div>
						<div className="viewHeader">
							<h1>Survey Questions</h1>
						</div>
						<div className="dataHeaders">
							<span style={{ flex: '0 0 75px', cursor: 'pointer' }}>Active</span>
							<span style={{ flex: '1 0 20%', textAlign: 'center', cursor: 'pointer' }}>Question Description</span>
							<span style={{ flex: '1 0 30%', textAlign: 'center', cursor: 'pointer' }}>Date Created</span>
							<span style={{ flex: '1 0 50px', textAlign: 'center' }}/>
							<span style={{ flex: '1 0 50px', textAlign: 'center' }}/>
							
						</div>
					</div>
				)

				var questions = [];

				for (let i in data.Surveys.surveyQuestions) {
					let item = data.Surveys.surveyQuestions[i]
					questions.push(item)
				}
				console.log('data.Surveys.surveyQuestions')
				console.log(data.Surveys.surveyQuestions)

				questions = questions.slice()

				//sort by date created for this table, oldest on bottom
				questions.sort(this.sortFunc('questionPosition', 1))

				for (let i in questions) {
					let question = questions[i];
					var datetimeCreated = moment(question.questionDatetimeCreated).format('MM/DD/YYYY h:mm:ss a');

					contentMain.push(
						<div className="dataRow" key={question.questionId} onClick={this.showEditBox('SurveyQuestions', question)}>
							<span style={{ flex: '0 0 75px', cursor: 'pointer' }}>
								<div className="activeBox">
									<div className={question.questionActive ? "enabled" : "disabled"}></div>
								</div>
							</span>
							<span style={{ flex: '1 0 20%', textAlign: 'center' }}>{question.questionDescription + ' (ver. ' + question.questionVersion + ')'}</span>
							<span style={{ flex: '1 0 30%', textAlign: 'center' }}>{datetimeCreated}</span>
							<span style={{ flex: '1 0 50px', textAlign: 'center' }}>{i > 0 ? <div onClick={this.moveQuestionUp(question)}>Move Up</div> : ''}</span>
							<span style={{ flex: '1 0 50px', textAlign: 'center' }}>{i < (questions.length - 1) ? <div onClick={this.moveQuestionDown(question)}>Move Down</div> : ''}</span>
							<span className="buttonBox" style={{ flex: '0 0 50px' }}>
								<img src={this.props.img.delete} alt="Delete Question" onClick={this.showDeleteBox('SurveyQuestions', question)} />
							</span>
						</div>
					)
				}
			}
			if (this.state.editBox === 'setting') {
				console.log('this.state.selectedObject');
				console.log(this.state.selectedObject);
				let editField = [];
				
									
				if (this.state.selectedObject.settingType == "boolean") {
					editField.push(
						<div className="activeBox" onClick={this.toggle('settingValue')}>
							<div className={this.state.selectedObject.settingValue ? 'enabled' : 'disabled'}></div>
						</div>
					)
				} else if (this.state.selectedObject.settingType == "int") {
					editField.push(
						<div className="snazzyInputBox">
							<input className="textInput" type="number" required value={this.state.selectedObject.settingValue} onChange={this.editParam('settingValue')} ></input>
						</div>
					)
				} else if (this.state.selectedObject.settingType == "tts") {
					console.log('tts');
					console.log(this.state.selectedObject)
					editField.push(
						<div>
							<div style={{ display: 'flex' }}>
								<div style={{ margin: '10px' }}>Prompt Type</div>
								<ReactSuperSelect style={{ flex: '1 0 150px', margin: '10px', display: 'inline-block' }} onChange={this.toggleSettingPromptType()} initialValue={{ id: 'tts', name: 'TTS' }} placeholder={"Action"} clearable={false} closeOnSelectedOptionClick={false} dataSource={[{ id: 'tts', name: 'TTS' }, { id: 'upload', name: 'Upload'}]} />
							</div>
							<textarea className="bigTextInput" required value={this.state.selectedObject.settingPromptText} onChange={this.editParam('settingPromptText')} ></textarea>
							<div style={{ color: this.state.selectedObject.settingPromptText.length > 500 ? '#937' : '', textAlign: 'right', paddingRight: '15px', top: '-15px', fontSize: '14px', position: 'relative' }}>{this.state.selectedObject.settingPromptText.length}/500</div>
						</div>
					);
				} else if (this.state.selectedObject.settingType == "upload") {
					editField.push(
						<div>
							<div style={{ display: 'flex' }}>
								<div style={{ margin: '10px' }}>Prompt Type</div>
								<ReactSuperSelect style={{ flex: '1 0 150px', margin: '10px', display: 'inline-block' }} onChange={this.toggleSettingPromptType()} initialValue={{ id: 'upload', name: 'Upload' }} placeholder={"Action"} clearable={false} closeOnSelectedOptionClick={false} dataSource={[{ id: 'tts', name: 'TTS' }, { id: 'upload', name: 'Upload'}]} />
							</div>
							<div style={{ display: 'inline-block', width: '100%' }}>
								<audio id="recordingPlayer" style={{ width: "300px"}} src={this.state.selectedObject.settingPromptUrl} download={this.state.activeCall + '.wav'} controls controlsList="nofullscreen nodownload noremoteplayback" />
								<label className="button" htmlFor={'uploadButton'}>Browse</label>
								<input style={{ width: '0.1px', height: '0.1px', opacity: '0', overflow: 'hidden', position: 'absolute', zIndex: '-1' }} type="file" accept=".wav" id={'uploadButton'} onChange={this.uploadSettingPrompt()} />
							</div>
						</div>
					);
				} else {
					editField.push(
						<div className="snazzyInputBox">
							<input className="textInput" type="text" required value={this.state.selectedObject.settingValue} onChange={this.editParam(this.state.selectedObject.settingValue)} ></input>
						</div>
					)
					
				}
				contentEditBox = (
					<div className="blackout" tabIndex="1" autoFocus >
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>{this.state.selectedObject.settingDisplayName}</div>

							{editField}

							<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmChanges('setting', this.state.selectedObject)}>Confirm</div>}
						</div>
					</div>
				)
			} else if (this.state.editBox === 'SurveyQuestions') {
				let questionFields = [];

				for (let i in this.state.selectedObject.questionData) {
					let promptText = this.state.selectedObject.questionData[i].promptText;
					let promptType = this.state.selectedObject.questionData[i].promptType;
					let allowTypeChange = this.state.selectedObject.questionData[i].allowTypeChange;

					if (this.state.selectedObject.questionData[i].promptType == 'text') {
						questionFields.push(
							<div>
								<label className="bigTextInput">Survey Question {i}</label>
								{allowTypeChange == true ?
									<div style={{ display: 'flex' }}>
										<div style={{ margin: '10px' }}>Prompt Type</div>
										<ReactSuperSelect style={{ flex: '1 0 150px', margin: '10px', display: 'inline-block' }} onChange={this.toggleQuestionType(i)} initialValue={{ id: promptType, name: promptType.charAt(0).toUpperCase() + promptType.slice(1) }} placeholder={"Action"} clearable={false} closeOnSelectedOptionClick={false} dataSource={[{ id: 'text', name: 'Text' }, { id: 'upload', name: 'Upload'}]} />
									</div>
								: ''}
								<textarea className="bigTextInput" required value={promptText} onChange={this.editParam('questionData', i, 'promptText')} ></textarea>
								<div style={{ color: promptText.length > 500 ? '#937' : '', textAlign: 'right', paddingRight: '15px', top: '-15px', fontSize: '14px', position: 'relative' }}>{promptText.length}/500</div>
							</div>
						);
					} else if (this.state.selectedObject.questionData[i].promptType == 'upload') {

						questionFields.push(
							<div>
								<label className="bigTextInput">Survey Question {i}</label>
								{allowTypeChange == true ?
									<div style={{ display: 'flex' }}>
										<div style={{ margin: '10px' }}>Prompt Type</div>
										<ReactSuperSelect style={{ flex: '1 0 150px', margin: '10px', display: 'inline-block' }} onChange={this.toggleQuestionType(i)} initialValue={{ id: promptType, name: promptType.charAt(0).toUpperCase() + promptType.slice(1) }} placeholder={"Action"} clearable={false} closeOnSelectedOptionClick={false} dataSource={[{ id: 'text', name: 'Text' }, { id: 'upload', name: 'Upload'}]} />
									</div>
								: ''}
								<div style={{ display: 'inline-block', width: '100%' }}>
									<audio id="recordingPlayer" style={{ width: "300px"}} src={this.state.selectedObject.questionData[i].promptUrl} download={this.state.activeCall + '.wav'} controls controlsList="nofullscreen nodownload noremoteplayback" />
									<label className="button" htmlFor={'uploadButton-' + i}>Browse</label>
									<input style={{ width: '0.1px', height: '0.1px', opacity: '0', overflow: 'hidden', position: 'absolute', zIndex: '-1' }} type="file" accept=".wav" id={'uploadButton-' + i} onChange={this.uploadQuestionPrompt(i)} />
								</div>
								
								<br /><br /><br /><br />
							</div>
						);
					}
				}

				contentEditBox = (
					<div className="blackout" tabIndex="1" autoFocus >
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>You Are Editing Survey Question: {this.state.selectedObject.questionDescription}</div>
							<br />

							{questionFields}
							
							<div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}>
								<div >
									<div>Option 1 is Voicemail</div>
									<div className="activeBox" onClick={this.toggle('enableVoicemail')}>
										<div className={this.state.selectedObject.enableVoicemail ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>

							{this.state.selectedObject.enableVoicemail ?
								<div className="snazzyInputBox">
									<label className="bigLabel">Option 1</label>
									<input className="textInput" type="text" required value='Leave A Voicemail' disabled={true} onChange={this.editParam('questionOption1')} ></input>
									<br/>
								</div>
							:
								<div className="snazzyInputBox">
									<label className="bigLabel">Option 1</label>
									<input className="textInput" type="text" required value={this.state.selectedObject.questionOption1} onChange={this.editParam('questionOption1')} ></input>
									<br/>
								</div>
							}

							<div className="snazzyInputBox">
								<label className="bigLabel">Option 2</label>
								<input className="textInput" type="text" required value={this.state.selectedObject.questionOption2} onChange={this.editParam('questionOption2')} ></input>
							</div>

							<div className="snazzyInputBox">
								<label className="bigLabel">Option 3</label>
								<input className="textInput" type="text" required value={this.state.selectedObject.questionOption3} onChange={this.editParam('questionOption3')} ></input>
							</div>

							<div className="snazzyInputBox">
								<label className="bigLabel">Option 4</label>
								<input className="textInput" type="text" required value={this.state.selectedObject.questionOption4} onChange={this.editParam('questionOption4')} ></input>
							</div>

							<div className="snazzyInputBox">
								<label className="bigLabel">Option 5</label>
								<input className="textInput" type="text" required value={this.state.selectedObject.questionOption5} onChange={this.editParam('questionOption5')} ></input>
							</div>

							<div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}>
								<div >
									<div>Active</div>
									<div className="activeBox" onClick={this.toggle('questionActive')}>
										<div className={this.state.selectedObject.questionActive ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>

							<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmChanges('SurveyQuestions', this.state.selectedObject)}>Confirm</div>}
						</div>
					</div>
				)
			} else if (this.state.addBox === 'SurveyQuestions') {
				let questionFields = [];
				for (let i in this.state.selectedObject.questionData) {
					let promptText = this.state.selectedObject.questionData[i].promptText;
					let promptType = this.state.selectedObject.questionData[i].promptType;
					let allowTypeChange = this.state.selectedObject.questionData[i].allowTypeChange;

					if (this.state.selectedObject.questionData[i].promptType == 'text') {
						questionFields.push(
							<div>
								<label className="bigTextInput">Survey Question {i}</label>
								{allowTypeChange == true ?
									<div style={{ display: 'flex' }}>
										<div style={{ margin: '10px' }}>Prompt Type</div>
										<ReactSuperSelect style={{ flex: '1 0 150px', margin: '10px', display: 'inline-block' }} onChange={this.toggleQuestionType(i)} initialValue={{ id: promptType, name: promptType.charAt(0).toUpperCase() + promptType.slice(1) }} placeholder={"Action"} clearable={false} closeOnSelectedOptionClick={false} dataSource={[{ id: 'text', name: 'Text' }, { id: 'upload', name: 'Upload'}]} />
									</div>
								: ''}
								<textarea className="bigTextInput" required value={promptText} onChange={this.editParam('questionData', i, 'promptText')} ></textarea>
								<div style={{ color: promptText.length > 500 ? '#937' : '', textAlign: 'right', paddingRight: '15px', top: '-15px', fontSize: '14px', position: 'relative' }}>{promptText.length}/500</div>
							</div>
						);
					} else if (this.state.selectedObject.questionData[i].promptType == 'upload') {

						questionFields.push(
							<div>
								<label className="bigTextInput">Survey Question {i}</label>
								{allowTypeChange == true ?
									<div style={{ display: 'flex' }}>
										<div style={{ margin: '10px' }}>Prompt Type</div>
										<ReactSuperSelect style={{ flex: '1 0 150px', margin: '10px', display: 'inline-block' }} onChange={this.toggleQuestionType(i)} initialValue={{ id: promptType, name: promptType.charAt(0).toUpperCase() + promptType.slice(1) }} placeholder={"Action"} clearable={false} closeOnSelectedOptionClick={false} dataSource={[{ id: 'text', name: 'Text' }, { id: 'upload', name: 'Upload'}]} />
									</div>
								: ''}
								<div style={{ display: 'inline-block', width: '100%' }}>
									<audio id="recordingPlayer" style={{ width: "300px"}} src={this.state.selectedObject.questionData[i].promptUrl} download={this.state.activeCall + '.wav'} controls controlsList="nofullscreen nodownload noremoteplayback" />
									<label className="button" htmlFor={'uploadButton-' + i}>Browse</label>
									<input style={{ width: '0.1px', height: '0.1px', opacity: '0', overflow: 'hidden', position: 'absolute', zIndex: '-1' }} type="file" accept=".wav" id={'uploadButton-' + i} onChange={this.uploadQuestionPrompt(i)} />
								</div>
								
								<br /><br /><br /><br />
							</div>
						);
					}
				}

				contentEditBox = (
					<div className="blackout" tabIndex="1" autoFocus >
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>You Are Adding A New Survey Question</div>
							<br />

							<div className="snazzyInputBox">
								<input className="textInput" type="text" required onChange={this.editParam('questionDescription')} ></input>
								<span className="inputBar"></span><label className="textLabel">Survey Question Description</label>
							</div>

							{questionFields}

							<div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}>
								<div >
									<div>Option 1 is Voicemail</div>
									<div className="activeBox" onClick={this.toggle('enableVoicemail')}>
										<div className={this.state.selectedObject.enableVoicemail ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>
							
							{this.state.selectedObject.enableVoicemail ?
								<div className="snazzyInputBox">
									<label className="bigLabel">Option 1</label>
									<input className="textInput" type="text" required value='Leave A Voicemail' disabled={true} onChange={this.editParam('questionOption1')} ></input>
									<br/>
								</div>
							:
								<div className="snazzyInputBox">
									<label className="bigLabel">Option 1</label>
									<input className="textInput" type="text" required value={this.state.selectedObject.questionOption1} onChange={this.editParam('questionOption1')} ></input>
									<br/>
								</div>
							}

							<div className="snazzyInputBox">
								<label className="bigLabel">Option 2</label>
								<input className="textInput" type="text" required value={this.state.selectedObject.questionOption2} onChange={this.editParam('questionOption2')} ></input>
							</div>

							<div className="snazzyInputBox">
								<label className="bigLabel">Option 3</label>
								<input className="textInput" type="text" required value={this.state.selectedObject.questionOption3} onChange={this.editParam('questionOption3')} ></input>
							</div>

							<div className="snazzyInputBox">
								<label className="bigLabel">Option 4</label>
								<input className="textInput" type="text" required value={this.state.selectedObject.questionOption4} onChange={this.editParam('questionOption4')} ></input>
							</div>

							<div className="snazzyInputBox">
								<label className="bigLabel">Option 5</label>
								<input className="textInput" type="text" required value={this.state.selectedObject.questionOption5} onChange={this.editParam('questionOption5')} ></input>
							</div>

							<div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}>
								<div >
									<div>Active</div>
									<div className="activeBox" onClick={this.toggle('questionActive')}>
										<div className={this.state.selectedObject.questionActive ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>

							<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmChanges('SurveyQuestions', this.state.selectedObject)}>Confirm</div>}
						</div>
					</div>
				)
			} else if (this.state.deleteBox == 'SurveyQuestions') {
				contentEditBox = (
					<div className="blackout" tabIndex="1" autoFocus>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>
							<div style={{ textAlign: 'center' }}>You are removing this survey question:</div>
							<div style={{ textAlign: 'center' }}>{this.state.selectedObject.questionDescription + ' (ver. ' + this.state.selectedObject.questionVersion + ')'}</div>
							<br />

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmDelete('SurveyQuestions', this.state.selectedObject)}>Delete Question</div>}
						</div>
					</div>
				)
			}
			
			return (
				<div className="viewContent" id="reportView" >
					<div style={{ overflow: 'auto', height: 'calc(100% - 45px)' }}>
						{contentMain}
					</div>
					{contentEditBox}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

const icon = "menuConverse"
const roles = ["View"]
export { Surveys, icon, roles }
